import { render, staticRenderFns } from "./market.module.vue?vue&type=template&id=5d0f65a0"
import script from "./market.module.vue?vue&type=script&lang=js"
export * from "./market.module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports